import React from 'react';
import PropTypes from 'prop-types';
import BrandTitle from './components/BrandTitle';
import Season from './components/Season';
import ProductTitle from './components/ProductTitle';
import ProductInfoCardWrapper from './styled/ProductInfoCardWrapper';
import PricesComponent from './components/PricesComponent';
import VerticalSpacer from '../VerticalSpacer/VerticalSpacer';
import AdminEditLink from './components/AdminEditLink';

const ProductDetailsProductInfo = props => {
  const {
    adminBaseUrl,
    currencySymbol,
    isDesktop,
    showSale = false,
    product: {
      approximatedConvertedPrice,
      brand,
      brandId,
      brandUrl,
      categoryPath,
      customerCurrencySymbol,
      currentPrice,
      originalPrice,
      productId,
      productVersionId,
      productName,
      reductionPercentage,
      season
    }
  } = props;

  const { category_id } = categoryPath || {};

  return (
    <ProductInfoCardWrapper data-cy-pid={productId} textAlign="left" fontSize="15px">
      <BrandTitle
        linkId={`brand-pr-${productId}`}
        brandName={brand}
        brandId={brandId}
        brandUrl={brandUrl}
        categoryId={category_id}
        fontSize={isDesktop ? '30px' : '15px'}
      />
      <VerticalSpacer height="16px" />
      <ProductTitle data-cy="model" productName={productName} detailed />
      <AdminEditLink adminBaseUrl={adminBaseUrl} productVersionId={productVersionId} productId={productId} />
      <VerticalSpacer height="5px" />
      <PricesComponent
        currencySymbol={currencySymbol}
        currentPrice={currentPrice}
        originalPrice={originalPrice}
        reductionPercentage={reductionPercentage}
        approximatedConvertedPrice={approximatedConvertedPrice}
        customerCurrencySymbol={customerCurrencySymbol}
        showSale={showSale}
      />
      <VerticalSpacer height="5px" />
      <Season season={season} />
    </ProductInfoCardWrapper>
  );
};

ProductDetailsProductInfo.defaultProps = {
  adminBaseUrl: null,
  isDesktop: false
};

ProductDetailsProductInfo.propTypes = {
  adminBaseUrl: PropTypes.string,
  isDesktop: PropTypes.bool,
  currencySymbol: PropTypes.string.isRequired,
  showSale: PropTypes.bool,
  product: PropTypes.shape({
    brand: PropTypes.string.isRequired,
    brandUrl: PropTypes.string.isRequired,
    productName: PropTypes.string.isRequired,
    currentPrice: PropTypes.string.isRequired,
    originalPrice: PropTypes.string.isRequired,
    reductionPercentage: PropTypes.string.isRequired,
    season: PropTypes.string.isRequired,
    approximatedConvertedPrice: PropTypes.string,
    customerCurrencySymbol: PropTypes.string,
    productId: PropTypes.string,
    productVersionId: PropTypes.string
  }).isRequired
};

export default ProductDetailsProductInfo;
